import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { AlbumState } from '../../Slice/Dashboard/AlbumSlice';
import { createAlbumAPI, deleteAlbumAPI, getAllAlbums, updateAlbumAPI } from '../../ApiCalls/Dashboard/AlbumAPI';
import { Folder, Albums } from '../../../Data/album.dto';
import { getFoldersForAlbum } from '../../ApiCalls/Dashboard/FolderApi';
import { showErrorToast, showSuccessToast } from '../../../components/atoms/Utlis/Toast';
import store from '../../Store';
import { trackClarityEvent } from '../../../analytics/ClarityAnalytics';
import { CLARITY_EVENTS } from '../../../analytics/EventTypes';
export const AlbumReducer = (builder: ActionReducerMapBuilder<AlbumState>) => {

    builder.addCase(getAllAlbums.pending, (state) => {
        state.loading = true;
        // Keep existing albums so count/pagination don't flash to empty during refetch
    })
        .addCase(getAllAlbums.fulfilled, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isSearchData = false;
            const payload = action.payload ?? {};
            const results = Array.isArray(payload.results) ? payload.results : [];
            const count =
                typeof payload.count === 'number'
                    ? payload.count
                    : results.length;
            state.total_projects = count;
            state.albums = results;
            if (payload.stats) {
                state.stats = {
                    total: payload.stats.total ?? 0,
                    locked: payload.stats.locked ?? 0,
                    hidden: payload.stats.hidden ?? 0,
                    watermark: payload.stats.watermark ?? 0,
                };
            }
            const page =
                typeof payload.page === 'number'
                    ? payload.page
                    : state.currentPage;
            state.currentPage = page;
            state.isUpdate = false;

            // Last item(s) deleted on this page → jump to last valid page and refetch
            const pageSize = 6;
            const maxPage = Math.max(1, Math.ceil(count / pageSize));
            if (results.length === 0 && count > 0 && page > maxPage) {
                state.currentPage = maxPage;
                state.isUpdate = true;
            } else if (results.length === 0 && count > 0 && page > 1) {
                state.currentPage = page - 1;
                state.isUpdate = true;
            }
        })
        .addCase(getAllAlbums.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = true;
            state.isUpdate = false
            // console.log(action.payload);
            if (action.payload && action.payload.message && action.payload.status && action.payload.status !== 401) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        }).addCase(createAlbumAPI.pending, (state) => {
            state.loading = true;

        })
        .addCase(createAlbumAPI.fulfilled, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isUpdate = true;

            showSuccessToast('New Album Created.')
            trackClarityEvent(CLARITY_EVENTS.ALBUM_CREATED, {
                album_id: action.payload?.id || action.payload?.project_id,
                album_name: action.payload?.name,
            })
        })
        .addCase(createAlbumAPI.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = true;

            // console.log(action.payload);
            if (action.payload && action.payload.message && action.payload.status && action.payload.status !== 401) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        }).addCase(updateAlbumAPI.pending, (state) => {
            state.loading = true;

        })
        .addCase(updateAlbumAPI.fulfilled, (state, action: PayloadAction<any>) => {
            state.loading = false;
            showSuccessToast("Album updated successfully.")
            state.isUpdate = true;

            trackClarityEvent(CLARITY_EVENTS.ALBUM_EDITED, {
                album_id: action.payload?.id || action.payload?.project_id,
                album_name: action.payload?.name,
            })
        }).addCase(updateAlbumAPI.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = true;

            if (action.payload && action.payload.message && action.payload.status && action.payload.status !== 401) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        }).addCase(deleteAlbumAPI.pending, (state) => {
            // Keep list visible while deleting; avoid wiping count/pagination
        })
        .addCase(deleteAlbumAPI.fulfilled, (state, action) => {
            state.loading = false;
            showSuccessToast("Album deleted successfully.")
            const albumId = action.meta.arg.album_id;
            state.albums = (state.albums as Albums[]).filter((album: Albums) => album.id !== albumId);
            if (state.total_projects > 0) {
                state.total_projects -= 1;
            }
            if (state.currentAlbum?.id === albumId) {
                delete state.currentAlbum;
            }
            const pageSize = 6;
            const maxPage = Math.max(1, Math.ceil(state.total_projects / pageSize));
            if (state.currentPage > maxPage) {
                state.currentPage = maxPage;
            }
            state.isUpdate = true;
        })
        .addCase(deleteAlbumAPI.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = true;

            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        })
        .addCase(getFoldersForAlbum.pending, (state) => {

            state.folderLoading = true;
            state.isError = false;
            state.error = {};
            state.isUpdate = false
            // state.albums = [];
        })
        .addCase(getFoldersForAlbum.fulfilled, (state, action: PayloadAction<{ folders: Folder[], album_id: number }>) => {
            console.log(action.payload);
            if (action.payload.folders) {

                if (action.payload.folders.length > 0) {
                    state.isFolderChange = false;
                    if (state.currentAlbum) {
                        if (state.currentAlbum.id === action.payload.folders[0].project_id)
                            state.currentAlbum.folders = action.payload.folders;
                    }
                    state.albums.forEach((album) => {
                        if (album.id === action.payload.folders[0].project_id) {
                            album.folders = action.payload.folders;
                        }
                    })
                }
                state.updatedFolderList = state.updatedFolderList.filter(
                    (folder) => folder.project_id !== action.payload.folders[0].project_id,
                )
            } else {
                if (state.currentAlbum && state.currentAlbum.id === action.payload.album_id) {
                    state.currentAlbum.folders = [];
                    state.updatedFolderList = state.updatedFolderList.filter(
                        (folder) => folder.project_id !== action.payload.album_id,
                    )
                }
            }
            state.folderLoading = false;
            state.isFolderChange = false;

        })
        .addCase(getFoldersForAlbum.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.folderLoading = false;
            state.isFolderChange = false;
            if (action.payload.status === 404 || action.payload.status === 401) {

            } else {
                state.isError = true;
                if (action.payload && action.payload.message) {
                    showErrorToast(action.payload.message)
                } else {
                    showErrorToast("Something went wrong.Please try again later.")
                }

            }

        })


};